import { render } from "./PerfilMenuView.vue?vue&type=template&id=75e3c882"
import script from "./PerfilMenuView.vue?vue&type=script&lang=js"
export * from "./PerfilMenuView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__